/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Description/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Description({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Description"
  
}) {
let appDescriptionValueData = fromData.useDataValue({ viewPath,
context: 'app',
path: 'description',
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="app.description"
 text={appDescriptionValueData}
 color={dtColorsNeutral500}
/>
{children}
</React.Fragment>)
}